import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { theme } from './styles/theme';
import HomePage from './pages/HomePage';
import GanttPage from './pages/GanttPage';
import TaskDetailPage from './pages/TaskDetailPage';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/gantt" element={<GanttPage />} />
          <Route path="/task/:taskId" element={<TaskDetailPage />} />
          <Route path="/task/:taskId/edit" element={<TaskDetailPage edit />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
